import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import './ui.css';
import './index.css';
import App from './App';
import { captureAttribution } from './utils/attribution';
import { captureInvite } from './utils/invite';
import { applyTheme, getThemePreference } from './utils/theme';

// UTM-метки, ?ref= и ?promo= из ссылки запоминаем до входа — отправим после регистрации
captureAttribution();
// Приглашение организатора (?invite=) применится после входа
captureInvite();
// Тёмная тема кабинета — до первой отрисовки, чтобы не мигал светлый экран
if (/^\/(dashboard|profile|help|qa-host\/|qa\/?$)/.test(window.location.pathname)) {
  applyTheme(getThemePreference());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

